import * as React from "react";
import { SVGProps } from "react";
export function AreaOfExpertiseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19.818 19.819"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m8.84 2.657 8.322 8.322M3.306 18.563l-2.05-2.049a1.493 1.493 0 0 1 0-2.113L7.829 7.83V3.668l2.411-2.412a1.494 1.494 0 0 1 2.113 0l6.21 6.21a1.493 1.493 0 0 1 0 2.113L16.15 11.99h-4.159L5.42 18.563a1.493 1.493 0 0 1-2.112 0h-.001Z"
        stroke="#000"
        strokeWidth={1.636}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
